import { ReactComponent as Done } from "../../assets/icons/add.svg";
import { ReactComponent as Plus } from "../../assets/icons/add-icon.svg";
import { ReactComponent as Question } from "../../assets/icons/question-mark.svg";
import { ReactComponent as ListGray } from "../../assets/icons/list_gray_ic.svg";
import { ReactComponent as Grid } from "../../assets/icons/grid_grey_ic.svg";
import { ReactComponent as Lock } from "../../assets/icons/lock.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as CloseWhite } from "../../assets/icons/close-white.svg";
import { ReactComponent as CheckedRadio } from "../../assets/icons/checked.svg";
import { ReactComponent as UnCheckedRadio } from "../../assets/icons/unchecked.svg";
import { ReactComponent as CheckOutline } from "../../assets/icons/check_outline_ic.svg";
import { ReactComponent as CheckedIcon } from "../../assets/icons/on.svg";
import { ReactComponent as UncheckedIcon } from "../../assets/icons/off.svg";
import { ReactComponent as Brief } from "../../assets/icons/brief.svg";
import { ReactComponent as AccountDetails } from "../../assets/icons/account_details.svg";
import { ReactComponent as SigningPreferences } from "../../assets/icons/signing_preferences.svg";
import { ReactComponent as Channels } from "../../assets/icons/channels.svg";
import { ReactComponent as ValueAddedServices } from "../../assets/icons/value_added_services.svg";
import { ReactComponent as QuestionMarkGray } from "../../assets/icons/question_mark_grey.svg";
import { ReactComponent as Info } from "../../assets/icons/info.svg";
import { ReactComponent as InfoYellow } from "../../assets/icons/infoYellow.svg";
import { ReactComponent as InfoRed } from "../../assets/icons/infoRed.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrowDown.svg";
import { ReactComponent as Error } from "../../assets/images/error.svg";
import { ReactComponent as File } from "../../assets/icons/file.svg";
import { ReactComponent as MinimizeChat } from "../../assets/icons/chat-minimize.svg";
import { ReactComponent as Bolt } from "../../assets/icons/bolt.svg";
import { ReactComponent as KycAnnexure } from "../../assets/icons/kyc_annexure.svg";

export const iconComponents = {
  done: Done,
  plus: Plus,
  question: Question,
  listGray: ListGray,
  grid: Grid,
  lock: Lock,
  close: Close,
  closeWhite: CloseWhite,
  checkedRadio: CheckedRadio,
  unCheckedRadio: UnCheckedRadio,
  checkOutline: CheckOutline,
  checkedIcon: CheckedIcon,
  uncheckedIcon: UncheckedIcon,
  brief: Brief,
  accountDetails: AccountDetails,
  signingPreferences: SigningPreferences,
  channels: Channels,
  valueAddedServices: ValueAddedServices,
  questionMarkGray: QuestionMarkGray,
  info: Info,
  infoYellow: InfoYellow,
  infoRed: InfoRed,
  arrowDown: ArrowDown,
  error: Error,
  file: File,
  minimizeChat: MinimizeChat,
  bolt: Bolt,
  kycAnnexure: KycAnnexure
};

export const ICONS = {
  done: "done",
  plus: "plus",
  question: "question",
  listGray: "listGray",
  grid: "grid",
  lock: "lock",
  close: "close",
  closeWhite: "closeWhite",
  checkedRadio: "checkedRadio",
  unCheckedRadio: "unCheckedRadio",
  checkOutline: "checkOutline",
  checkedIcon: "checkedIcon",
  uncheckedIcon: "uncheckedIcon",
  brief: "brief",
  accountDetails: "accountDetails",
  signingPreferences: "signingPreferences",
  channels: "channels",
  valueAddedServices: "valueAddedServices",
  questionMarkGray: "questionMarkGray",
  info: "info",
  infoYellow: "infoYellow",
  infoRed: "infoRed",
  arrowDown: "arrowDown",
  error: "error",
  file: "file",
  minimizeChat: "minimizeChat",
  bolt: "bolt",
  kycAnnexure: "kycAnnexure"
};
